import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import { Anchor } from '../atom/Anchor';

import * as PATH from '../../../lib/routes/path';

const EventBanner = ({
  id,
  image: { alt, src },
  isEventItemOn: { isEventBannerOn, isMaskOn },
  url,
  path,
}) => {
  return (
    isEventBannerOn && (
      url ? (
        <Anchor href={url} key={id}>
          <RelativeDiv>
            {isMaskOn && (
              <EventBannerMask>
                <Text weight="bold" color="background" size="20">
                  {BANNER_MASK_TITLE}
                </Text>
              </EventBannerMask>
            )}
            <img src={src} alt={alt} width="100%" />
          </RelativeDiv>
        </Anchor>
      ) : path ? (
        <Link to={path}>
          <RelativeDiv>
            {isMaskOn && (
              <EventBannerMask>
                <Text weight="bold" color="background" size="20">
                  {BANNER_MASK_TITLE}
                </Text>
              </EventBannerMask>
            )}
            <img src={src} alt={alt} width="100%" />
          </RelativeDiv>
        </Link>
      ) : (
        <Link to={`${PATH.EVENT_DETAIL}/${id}`}>
          <RelativeDiv>
            {isMaskOn && (
              <EventBannerMask>
                <Text weight="bold" color="background" size="20">
                  {BANNER_MASK_TITLE}
                </Text>
              </EventBannerMask>
            )}
            <img src={src} alt={alt} width="100%" />
          </RelativeDiv>
        </Link>
      )
    )
  );
};

export default React.memo(EventBanner);

const BANNER_MASK_TITLE = '종료된 이벤트입니다.';
const RelativeDiv = styled.div`
  position: relative;
  margin-bottom: 1.526rem;
`;

const EventBannerMask = styled(Flex)`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(74, 74, 74, 0.6);
`;
